// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"9cf4e9ed","112":"0eeafbce","188":"039515dd","292":"bb854585","340":"9a3b0844","488":"751f889f","530":"3dd2fad1","708":"64ceb826","870":"711d2789","946":"723d75a3","986":"ef5edc94"}[chunkId] + ".chunk.js";
};